export const ASYNC_CREATE_MARKETING_PLAN = 'ASYNC_CREATE_MARKETING_PLAN';
export const ASYNC_EDIT_MARKETING_PLAN = 'ASYNC_EDIT_MARKETING_PLAN';
export const ASYNC_CHANGE_STATUS_MARKETING_PLAN =
  'ASYNC_CHANGE_STATUS_MARKETING_PLAN';
export const ASYNC_LANDING_APPROVAL = 'ASYNC_LANDING_APPROVAL';
